"use client"

import { HTMLContent } from "./shared/html-content"

export function FeedbackMessage({
	responseId,
	showFeedback,
	perResponseFeedback
}: {
	responseId: string
	showFeedback?: boolean
	perResponseFeedback?: Record<string, { isCorrect: boolean; messageHtml?: string }>
}) {
	if (!showFeedback) return null
	const entry = perResponseFeedback?.[responseId]
	const messageHtml = entry?.messageHtml
	if (!messageHtml) return null
	const isCorrect = entry?.isCorrect === true
	return (
		<div className="qti-feedback mt-3 p-6" data-correct={isCorrect}>
			<HTMLContent html={messageHtml} />
		</div>
	)
}

export default FeedbackMessage
